import React, { useState } from "react";
import { useI18n } from "../i18n/I18nContext";
import { Plus, Minus } from "lucide-react";

const FAQAccordion = () => {
  const { t } = useI18n();
  const [open, setOpen] = useState(0);
  return (
    <section className="bg-slate-50 border-t border-slate-200" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 lg:px-8 section">
        <div>
          <span className="accent-bar" />
          <p className="eyebrow mb-3">{t.faq.eyebrow}</p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.05]">
            {t.faq.title}
          </h2>
        </div>
        <div className="mt-10 border-t border-slate-200">
          {t.faq.items.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="border-b border-slate-200">
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left transition-colors"
                  data-testid={`faq-toggle-${i}`}
                >
                  <span className="font-display font-semibold text-base sm:text-lg pr-4">{it.q}</span>
                  {isOpen ? <Minus size={18} className="text-[#016C36] shrink-0" /> : <Plus size={18} className="text-slate-400 shrink-0" />}
                </button>
                {isOpen && (
                  <div className="pb-6 text-slate-600 leading-relaxed max-w-3xl" data-testid={`faq-content-${i}`}>
                    {it.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQAccordion;
